import { jsx as _jsx } from "react/jsx-runtime";
import { CheckableAvatarSelectItem, Select } from '@dixa/lib-shared-habla';
import { memo, useCallback } from 'react';
import { useAgents } from 'hooks/useAgents';
export const AgentsSelect = memo(({ teamId, queueId, selectedItems, selectAgent, deselectAgent }) => {
    const { items: agents, changeParams, asyncStatus, params, hasNextPage, hasPreviousPage, nextPage, previousPage, } = useAgents({
        filter_out_by_team: teamId,
        filter_out_by_queue: queueId,
    });
    const handleChange = useCallback((agent, isSelected) => {
        if (isSelected) {
            selectAgent(agent);
        }
        else {
            deselectAgent(agent);
        }
    }, [deselectAgent, selectAgent]);
    return (_jsx(Select, { placeholder: "Select one or more agents", items: agents, selectedItems: selectedItems, onSearch: (searchValue) => changeParams({ search: searchValue }), onChange: handleChange, loading: asyncStatus === 'loading', emptyMessage: params.search ? 'No agents found' : 'No agents available', pagination: {
            nextEnable: hasNextPage,
            previousEnable: hasPreviousPage,
            onNext: nextPage,
            onPrevious: previousPage,
        }, itemComponent: CheckableAvatarSelectItem, searchable: true, multiple: true }));
});
AgentsSelect.displayName = 'AgentsSelect';
